<template>
  <BaseButton
    text
    color="white"
    :class="isDisabledIconInAttr || isGuest ? 'disabled-icon' : ''"
    retain-focus-on-click
    :ripple="false"
    @click="createReportHandler()"
  >
    <BaseSpriteIcon icon-name="ico-reports"></BaseSpriteIcon>
    <span class="context-menu-text-item">{{ $t('Context.short.report') }}</span>
  </BaseButton>
</template>

<script>
import BaseSpriteIcon from '@/components/base/BaseSpriteIcon/BaseSpriteIcon.vue';
import BaseButton from '@/components/base/BaseButton/BaseButton';

import PopupNamesEnum from '@/enums/PopupNamesEnum';

export default {
  name: 'TypoControl',
  components: {
    BaseSpriteIcon,
    BaseButton
  },
  data() {
    return {
      disabledClass: ''
    };
  },
  computed: {
    bookId() {
      const openParams = this.$store.getters[
        'OpenParameterStore/getPublicationOpenParameters'
      ];
      return openParams?.publicationId;
    },
    selectedLocator() {
      return this.$store.getters['MaterialsStore/getSelectedLocator'];
    },
    isGuest() {
      return this.$store.getters['UserStore/isGuestUser'];
    },
    isDisabledIconInAttr() {
      return this.$attrs['icon-disabled'];
    }
  },
  methods: {
    openSocialSharingPopup() {
      this.$store.dispatch('ManagePopupStore/openPopup', {
        name: PopupNamesEnum.TYPO_POPUP,
        popupContext: {
          locators: this.selectedLocator,
          bookId: this.bookId,
          paraId: this.selectedLocator.startLocator.prefixedParagraphId
        }
      });
    },
    createReportHandler() {
      if (this.isDisabledIconInAttr && !this.isGuest) {
        this.$store.dispatch('ManagePopupStore/openToaster', {
          text: this.$t('ReportControl.toaster.disabled.message'),
          toasterClose: false
        });
        return;
      }
      this.$store.dispatch('PaymentsStore/wrappWithGuestLogic', {
        handler: this.openSocialSharingPopup
      });
    }
  }
};
</script>
